import { FC } from 'react';
import { lSTruck, lSLike } from '../../../../assets/images';
import './EmptyStateTrello.scss';

interface IEmptyStateTrello {
  text?: string;
  icon?: 'like' | 'truck';
}

const EmptyStateTrello: FC<IEmptyStateTrello> = ({ text, icon }: IEmptyStateTrello) => {
  return (
    <div id="emptyStateTrello">
      <div className="boxEmptyItems">
        <div className="centerVerticalItems">
          <div className="containerImg">
            <div className="limitsImg">
              <img alt="sl-icon" src={icon === 'like' ? lSLike : lSTruck} />
            </div>
          </div>
          <div className="containerText">
            <div className="emptyText">{text || 'Aqui va un texto'} </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyStateTrello;
